export default {
  namespaced: true,
  state: {
    step: 1,
    validSteps: [false, false, false, false, false],
    newApplication: {
      entity: null,
      applicationAddress: null,
      mailingAddress: null,
      frameworkEntity: null,
      applicationType: null,
      environmentalStudyTypeRequired: null,
      applicationSimplified: {qualify: false},
    },
    applicationTypesAvailable: [],
  },
  mutations: {
    SET_STEP(state, step) {
      state.step = step
    },
    SET_VALID_STEPS(state, value) {
      state.validSteps.splice(state.step - 1, 1, value);
    },
    NEXT_STEP(state) {
      state.step += 1
    },
    PREVIOUS_STEP(state) {
      state.step -= 1
    },
    SET_ENTITY(state, entity) {
      state.newApplication = { ...state.newApplication, entity }
    },
    SET_APPLICATION_ADDRESS(state, applicationAddress) {
      state.newApplication = { ...state.newApplication, applicationAddress };
    },
    SET_MAILING_ADDRESS(state, mailingAddress) {
      state.newApplication = { ...state.newApplication, mailingAddress }
    },
    SET_FRAMEWORK_ENTITY(state, frameworkEntity) {
      state.newApplication = { ...state.newApplication, frameworkEntity }
    },
    SET_APPLICATION_TYPE(state, applicationTypePayload) {
      state.newApplication = { ...state.newApplication, applicationType: applicationTypePayload }
    },
    SET_APPLICATION_TYPES_AVAILABLE(state, applicatinoTypesAvailable) {
      state.applicationTypesAvailable = applicatinoTypesAvailable
    },
    SET_ENVIRONMENTAL_STUDY_TYPE_REQUIRED(state, environmentalStudyTypeRequired) {
      state.newApplication = { ...state.newApplication, environmentalStudyTypeRequired }
    },
    SET_APPLICATION_SIMPLIFIED(state, applicationSimplified) {
      state.newApplication = { ...state.newApplication, applicationSimplified }
    }
  },
  actions: {
    setStep({ commit }, step) {
      commit('SET_STEP', step)
    },
    setValidSteps({ commit }, value) {
      commit('SET_VALID_STEPS', value)
    },
    nextStep({ commit }) {
      commit('NEXT_STEP')
    },
    previousStep({ commit }) {
      commit('PREVIOUS_STEP')
    },
    setEntity({ commit }, entity) {
      commit('SET_ENTITY', entity)
    },
    setApplicationAddress({ commit }, applicationAddress) {
      commit('SET_APPLICATION_ADDRESS', applicationAddress)
    },
    setMailingAddress({ commit }, mailingAddress) {
      commit('SET_MAILING_ADDRESS', mailingAddress)
    },
    setFrameworkEntity({ commit }, frameworkEntity) {
      commit('SET_FRAMEWORK_ENTITY', frameworkEntity)
    },
    setApplicationTypesAvailable({ commit }, applicationTypesAvailable) {
      commit('SET_APPLICATION_TYPES_AVAILABLE', applicationTypesAvailable)
    },
    setApplicationType({ commit }, applicationTypePayload) {
      commit('SET_APPLICATION_TYPE', applicationTypePayload)
    },
    setEnvironmentalStudyTypeRequired({ commit }, environmentalStudyTypeRequired) {
      commit('SET_ENVIRONMENTAL_STUDY_TYPE_REQUIRED', environmentalStudyTypeRequired)
    },
    setApplicationSimplified({ commit }, applicationSimplified) {
      commit('SET_APPLICATION_SIMPLIFIED', applicationSimplified)
    }
  },
  getters: {
    step: state => state.step,
    validSteps: state => state.validSteps, 
    newApplication: state => state.newApplication,
    applicationTypesAvailable: state => state.applicationTypesAvailable,
    applicationSimplified: state => state.newApplication.applicationSimplified,
    frameworkEntity: state => state.newApplication.frameworkEntity,
  }
};
